export const apiUrl =
  process.env.REACT_APP_API_URL ||
  'https://gateway.victoriousglacier-6eb82086.westeurope.azurecontainerapps.io/api';
